var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-content idml-preview" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "idml-preview-title" } },
        [
          _vm._v("\n      IDML Preview"),
          _vm.currentFile
            ? _c("span", [_vm._v(": " + _vm._s(_vm.currentFile.name))])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
          on: { click: _vm.cancelImport },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _vm.files.length > 1
          ? _c("div", { staticClass: "mb-3" }, [
              _c("label", { attrs: { for: "idml-preview-file" } }, [
                _vm._v("File"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.currentFileIndex,
                      expression: "currentFileIndex",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "idml-preview-file" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return _vm._n(val)
                          })
                        _vm.currentFileIndex = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.resetSelection,
                    ],
                  },
                },
                _vm._l(_vm.files, function (file, index) {
                  return _c(
                    "option",
                    { key: file.url, domProps: { value: index } },
                    [_vm._v("\n          " + _vm._s(file.name) + "\n        ")]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentFile && _vm.currentFile.isFetching
          ? _c(
              "div",
              { staticClass: "text-center py-5", attrs: { role: "status" } },
              [
                _c("span", { staticClass: "spinner-border text-primary" }),
                _vm._v(" "),
                _c("p", { staticClass: "mt-3" }, [
                  _vm._v("\n        Parsing IDML…\n      "),
                ]),
              ]
            )
          : _vm.currentFile && _vm.currentFile.error
          ? _c(
              "div",
              { staticClass: "alert alert-danger", attrs: { role: "alert" } },
              [
                _vm._v("\n      " + _vm._s(_vm.currentFile.error) + "\n      "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-danger btn-sm ml-2",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.loadFile(_vm.currentFile, true)
                      },
                    },
                  },
                  [_vm._v("\n        Retry\n      ")]
                ),
              ]
            )
          : _vm.currentFile && _vm.currentFile.data
          ? [
              _vm.currentFile.data.requiredImages.length
                ? _c("div", { staticClass: "alert alert-warning" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.currentFile.data.requiredImages.length) +
                        " image(s) need to be uploaded to be imported.\n        "
                    ),
                    _c("div", { staticClass: "mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-dark btn-sm",
                          attrs: {
                            type: "button",
                            disabled: _vm.currentFile.isResolving,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.linksFolderInput.click()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            Upload Links folder\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        ref: "linksFolderInput",
                        staticClass: "d-none",
                        attrs: {
                          type: "file",
                          multiple: "",
                          webkitdirectory: "",
                          directory: "",
                        },
                        on: { change: _vm.uploadLinksFolder },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "details",
                      { staticClass: "mt-2", attrs: { open: "" } },
                      [
                        _c("summary", [_vm._v("Required images")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "mb-0" },
                          _vm._l(
                            _vm.currentFile.data.requiredImages,
                            function (image, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  staticClass: "idml-preview__wrap",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        image.resourceUri ||
                                          image.imageId ||
                                          image.layerId ||
                                          "Unnamed image"
                                      ) +
                                      "\n              "
                                  ),
                                  image.status === "ambiguous"
                                    ? _c("span", [
                                        _vm._v(" — multiple matching files"),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-link btn-sm",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.currentFile.isResolving,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.chooseReplacement(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Replace\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.currentFile.isResolving
                      ? _c(
                          "div",
                          {
                            staticClass: "small mt-2",
                            attrs: { role: "status" },
                          },
                          [_vm._v("\n          Saving images…\n        ")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                ref: "replacementInput",
                staticClass: "d-none",
                attrs: { type: "file", accept: "image/*,.pdf,.psd,.eps" },
                on: { change: _vm.uploadReplacement },
              }),
              _vm._v(" "),
              _vm.uploadMessage
                ? _c(
                    "div",
                    {
                      staticClass: "alert",
                      class: _vm.uploadError ? "alert-danger" : "alert-info",
                      attrs: { role: "status" },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.uploadMessage) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
                _c(
                  "label",
                  {
                    staticClass: "mr-2 mb-0",
                    attrs: { for: "idml-preview-page" },
                  },
                  [_vm._v("Page")]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.pageIndex,
                        expression: "pageIndex",
                        modifiers: { number: true },
                      },
                    ],
                    staticClass: "form-control w-auto",
                    attrs: {
                      id: "idml-preview-page",
                      disabled: !_vm.pages.length,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return _vm._n(val)
                            })
                          _vm.pageIndex = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          _vm.selectedLayer = null
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.pages, function (page, index) {
                    return _c(
                      "option",
                      {
                        key: page.properties.id || index,
                        domProps: { value: index },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(page.name) +
                            " (" +
                            _vm._s(_vm.dimension(page.width)) +
                            " × " +
                            _vm._s(_vm.dimension(page.height)) +
                            " pt)\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.currentPage
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6 mb-3" },
                      [
                        _c("IDMLPagePreview", {
                          attrs: {
                            page: _vm.currentPage,
                            "preview-path": _vm.currentPreviewPath,
                            selected: _vm.selectedLayer,
                          },
                          on: {
                            select: function ($event) {
                              _vm.selectedLayer = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between mb-2",
                        },
                        [
                          _c("h6", { staticClass: "mb-0" }, [
                            _vm._v("\n              Layers\n            "),
                          ]),
                          _vm._v(" "),
                          _vm.isImportFlow
                            ? _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-link btn-sm",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setPageSelection(true)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Select all\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-link btn-sm",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setPageSelection(false)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Clear\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "idml-preview__layers" },
                        [
                          _c("IDMLLayersTree", {
                            attrs: {
                              nodes: _vm.currentPage.children || [],
                              selected: _vm.selectedLayer,
                              selectable: _vm.isImportFlow,
                              "selected-ids": _vm.selectedIds,
                            },
                            on: {
                              select: function ($event) {
                                _vm.selectedLayer = $event
                              },
                              toggle: _vm.toggleLayer,
                              "field-type": _vm.setFieldType,
                            },
                          }),
                          _vm._v(" "),
                          !_vm.currentPage.children ||
                          !_vm.currentPage.children.length
                            ? _c("p", [
                                _vm._v(
                                  "\n              No layers on this page.\n            "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _c("p", [
                    _vm._v("\n        No pages found in this file.\n      "),
                  ]),
              _vm._v(" "),
              _vm.unassignedLayers.length
                ? _c(
                    "details",
                    { staticClass: "mt-3" },
                    [
                      _c("summary", [
                        _vm._v(
                          "Items outside pages (" +
                            _vm._s(_vm.unassignedLayers.length) +
                            ")"
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isImportFlow
                        ? _c("p", { staticClass: "small text-muted mb-1" }, [
                            _vm._v(
                              "\n          Items outside pages are shown for reference and are not imported.\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("IDMLLayersTree", {
                        attrs: {
                          nodes: _vm.unassignedLayers,
                          selected: _vm.selectedLayer,
                        },
                        on: {
                          select: function ($event) {
                            _vm.selectedLayer = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedLayer
                ? _c(
                    "div",
                    {
                      staticClass: "border rounded p-3 mt-3 idml-preview__wrap",
                    },
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.selectedLayer.name))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "small text-muted" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.selectedLayer.properties.kind) +
                            " · " +
                            _vm._s(_vm.dimension(_vm.selectedLayer.width)) +
                            " × " +
                            _vm._s(_vm.dimension(_vm.selectedLayer.height)) +
                            " pt\n          · X: " +
                            _vm._s(_vm.dimension(_vm.selectedLayer.left)) +
                            ", Y: " +
                            _vm._s(_vm.dimension(_vm.selectedLayer.top)) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.selectedLayer.properties.text
                        ? _c(
                            "p",
                            { staticClass: "idml-preview__text mt-2 mb-0" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.textContent(
                                      _vm.selectedLayer.properties.text
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedLayer.properties.style
                        ? _c("div", { staticClass: "small mt-2" }, [
                            _c("div", [
                              _vm._v(
                                "Fill: " +
                                  _vm._s(
                                    _vm.paintDescription(
                                      _vm.selectedLayer.properties.style.fill
                                    )
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Stroke: " +
                                  _vm._s(
                                    _vm.paintDescription(
                                      _vm.selectedLayer.properties.style.stroke
                                    )
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedLayer.properties.image
                        ? [
                            _c("p", { staticClass: "mt-2 mb-0" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.selectedLayer.properties.image
                                      .requiresUpload
                                      ? "Image required"
                                      : "Image saved"
                                  ) +
                                  "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedLayer.properties.image.resourceUri
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-primary btn-sm mt-2",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.currentFile.isResolving,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.chooseLayerReplacement(
                                      _vm.selectedLayer
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            Replace image\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.selectedImageUrl
                              ? _c("img", {
                                  key: _vm.selectedImageUrl,
                                  staticClass: "idml-preview__image mt-2",
                                  attrs: {
                                    src: _vm.selectedImageUrl,
                                    alt: _vm.selectedLayer.name,
                                  },
                                  on: {
                                    error: function ($event) {
                                      _vm.failedImageUrl = _vm.selectedImageUrl
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _vm.isImportFlow
        ? _c("span", { staticClass: "mr-auto" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.selectedPagesCount) +
                " page(s), " +
                _vm._s(_vm.selectedLayersCount) +
                " layer(s) selected\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isImportFlow
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: {
                type: "button",
                disabled:
                  _vm.isImporting ||
                  !_vm.selectedLayersCount ||
                  _vm.hasSelectedMissingImages,
              },
              on: { click: _vm.importTemplates },
            },
            [
              _vm.isImporting
                ? _c("span", {
                    staticClass: "spinner-border spinner-border-sm mr-1",
                  })
                : _vm._e(),
              _vm._v("\n      Import selected layers\n    "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-outline-primary",
          attrs: {
            type: "button",
            disabled: !_vm.currentFile || _vm.currentFile.isFetching,
          },
          on: {
            click: function ($event) {
              return _vm.loadFile(_vm.currentFile, true)
            },
          },
        },
        [_vm._v("\n      Reparse IDML\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" },
          on: { click: _vm.cancelImport },
        },
        [_vm._v("\n      Close\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }